import script from "./FileUploader.vue?vue&type=script&lang=ts&setup=true"
export * from "./FileUploader.vue?vue&type=script&lang=ts&setup=true"

import "./FileUploader.vue?vue&type=style&index=0&id=758a6b50&lang=scss"

const __exports__ = script;

export default __exports__